import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class OaMissingTranslationHandler implements MissingTranslationHandler {
    public handle(params: MissingTranslationHandlerParams) {
        const key = params.key.split('.');
        console.warn('[TRANSLATION] Localization missing for key', params.key);
        return key.length > 0 ? key[key.length - 1] : params.key;
    }
}
